import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { detectPartnerContext } from "../utils/partnerHeader";

const PARTNER_DOMAIN = import.meta.env.VITE_PARTNER_DOMAIN || "procertcompliance.com";
const WhiteLabelContext = createContext({
  isWhiteLabel: false, partnerSlug: null, partnerDomain: PARTNER_DOMAIN,
});
export const useWhiteLabel = () => useContext(WhiteLabelContext);

export const WhiteLabelProvider = ({ children }) => {
  const location = useLocation();
  const {isWhiteLabel, partnerSlug} = detectPartnerContext({
    hostname:window.location.hostname,
    pathname:location.pathname,
    routePartnerSlug:location.state?.partnerSlug,
    metaSlug:document.querySelector('meta[name="x-partner-slug"]')?.content,
    whiteLabel:document.querySelector('meta[name="x-white-label"]')?.content === 'true',
    partnerDomain:PARTNER_DOMAIN,
  });
  const value = useMemo(() => ({isWhiteLabel,partnerSlug,partnerDomain:PARTNER_DOMAIN}),[isWhiteLabel,partnerSlug]);
  return <WhiteLabelContext.Provider value={value}>{children}</WhiteLabelContext.Provider>;
};
export default WhiteLabelContext;
